import { Component } from '@angular/core';
import {
  Page,
  TableViewAbstractComponent,
} from '../../ui/filterable-table/tableViewAbstractComponent';
import { UIErrorHandler } from '../../../core/uiErrorHandler';
import { UIHelpers } from '../../../core/ui-helpers';
import { SearchFilters } from '../../../models/search/searchFilters';
import { ChargebackFacade } from '../../../models/chargebacks/chargebackFacade';
import { ChargebacksService } from '../../../models/chargebacks/chargebacksService';

@Component({
  selector: 'app-chargebacks-table-view',
  templateUrl: './chargebacks-table-view.component.html',
  standalone: false,
})
export class ChargebacksTableViewComponent extends TableViewAbstractComponent {
  constructor(
    public chargebacksService: ChargebacksService,
    private uiErrorHandler: UIErrorHandler,
  ) {
    super();
  }

  getRecordFromDataSource(id: string): ChargebackFacade {
    for (var i = 0; i < this.dataSource.data.length; i++) {
      if (this.dataSource.data[i].id == id) {
        return this.dataSource.data[i];
      }
    }

    throw 'Chargeback not found in dataset';
  }

  getPageOfData(
    query: string,
    filters: SearchFilters,
    pageNum: number,
    pageSize: number,
    sortColumn: string,
    sortDirection: string,
  ): Promise<Page<ChargebackFacade>> {
    return this.chargebacksService
      .getChargebacks({
        pageNum: pageNum,
        pageSize: pageSize,
        sortColumn: sortColumn,
        sortDirection: sortDirection,
        userId: this.options.userId ? this.options.userId : '',
        merchantId: this.options.merchantId ? this.options.merchantId : '',
        query: query,
      })
      .catch((message) => {
        this.uiErrorHandler.handleError(message);
        return new Page<ChargebackFacade>({});
      });
  }

  canQuery(): boolean {
    if (this.options) {
      return (
        (this.options && this.options.merchantId != undefined) ||
        this.options.customerId != undefined ||
        this.options.userId != undefined
      );
    }
    return false;
  }

  _selectRow_click(id: string) {
    this.selectRow_click(id);
  }

  formatDate(
    date: string | undefined,
    defaultText: string | undefined,
  ): string {
    if (date) {
      return UIHelpers.formatDate(date);
    } else {
      return defaultText + '';
    }
  }

  getMonthName(value: string): string {
    return UIHelpers.getMonthAbbrFromNumber(value);
  }

  getFormattedCurrency(value: number): string {
    return UIHelpers.formatCurrency(value);
  }
}
